import { ICreateCupom, ICupomEvento } from "interfaces/cupom";
import api from "./api";

/**
 * Listar todos os cupons
 */
export async function getAllCupom() {
  try {
    return await api.get("/cupom");
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

/**
 * Buscart todos os cupom disponível para o evento
 * @param eventoId ID do evento
 * @returns <ICupomEvento[]>
 */
export async function getAllCupomEvento(
  eventoId: number
): Promise<ICupomEvento[]> {
  try {
    return (await api.get(`/cupom/${eventoId}`)).data;
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

/**
 * Excluir um cupom
 */
export async function deleteCupom(id: number) {
  try {
    return await api.delete(`/cupom/${id}`);
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

/**
 * criar um cupom
 */
export async function saveCupom(cupom: ICreateCupom) {
  try {
    return await api.post<ICupomEvento>("/cupom", cupom);
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

/**
 * atualizar um cupom
 */
export async function editCupom(
  cupom: ICreateCupom,
  cupomId: number,
  qtdCupomOld: number
) {
  try {
    return await api.put(`/cupom/${cupomId}`, cupom, {
      headers: {
        qtdCupomOld: qtdCupomOld,
      },
    });
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}
